module.exports = __webpack_public_path__ + "static/bg2.85e4a360.png";